export class RESTfulApi<T> {
    message: string;
    data: T;
    [key: string]: any;
}

export class ListResponse<T> {
    status: number;
    data: T[];
    message: string;

    constructor(data: T[]) {
        this.data = data;
    }
}

export class GetAllResponse<T> {
    status: number;
    data: T[];
    message?: string;

    constructor(data) {
        this.data = data;
    }
}

export class SingleResponse<T> {
    status: number;
    data: T;
    message?: string;
}

export const HTTP_STATUS_CODE = {
    SUCCESS: 200,
    INTERNAL_ERROR: 500,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOTFOUND: 404,
    FORBIDDEN: 403
};

